const Archive = () => import('./Main')

const route = {
  path: '/archive',
  name: 'archive',
  component: Archive
}

export default route
